import { Gender, Insurance } from '@core/constants/data-types.constants';
import { Duration } from 'date-fns';
import { CurrencyAmount } from './currency-amount.model';
import { DummyProduct, Product } from './product.model';

export type InsuranceTarget =
  | PointInTimeInsuranceTarget
  | TimePeriodInsuranceTarget
  | SavingInsuranceTarget
  | InvestmentInsuranceTarget;

export type InsuranceTargetType = 'point-in-time' | 'time-period' | 'saving' | 'investment' | 'child';

export interface IInsuranceTarget {
  id: string;
  name: string;
  surnames?: string;
  order: number;
  type: InsuranceTargetType;
  policyHolder: PolicyHolderData;
  insured: InsuredData;
  insurance: Insurance;
  currentProduct?: Product;
  milestone?: InsuranceTargetMilestone;
}

/**
 * This insurance is based on the milestone, so it is required
 */
export interface PointInTimeInsuranceTarget extends IInsuranceTarget {
  type: 'point-in-time';
  milestone: InsuranceTargetMilestone;
}

export interface TimePeriodInsuranceTarget extends IInsuranceTarget {
  type: 'time-period';
  duration: Duration;
  periodLabel: string;
}

export interface SavingInsuranceTarget extends IInsuranceTarget {
  type: 'saving';
  totalAmount: CurrencyAmount;
  savings: CurrencyAmount;
  assuredAmount: CurrencyAmount;
  date: string;
}

export interface InvestmentInsuranceTarget extends IInsuranceTarget {
  type: 'investment';
  totalSavings: CurrencyAmount;
}

export interface PolicyHolderData {
  gender: Gender;
  age: number;
  investorProfile: string;
  netMonthlyIncome?: CurrencyAmount | undefined;
}

export interface InsuredData {
  age: number;
  university?: string;
  universityCost?: CurrencyAmount;
}

export interface InsuranceTargetMilestone {
  userAge: number;
  year: number;
}

export const DummyInsuranceTarget: InsuranceTarget = {
  id: '',
  name: '',
  surnames: '',
  order: 0,
  type: 'point-in-time',
  insurance: 'DEATH',
  policyHolder: {
    age: 0,
    gender: '',
    investorProfile: ''
  },
  insured: {
    age: 0
  },
  milestone: {
    userAge: 0,
    year: 0
  },
  currentProduct: DummyProduct
};
